// extracted by mini-css-extract-plugin
module.exports = {"copyWrapper":"src-components-results-Hotel-Copy-styles__copyWrapper","copyTitle":"src-components-results-Hotel-Copy-styles__copyTitle"};